import { FilterSection, FilterSort } from '@/types';

export type State = {
    sections: FilterSection[];
    sort: FilterSort | null;
    url: string;
    resultsTotalCount: number;
}

export const state: State = {
    sections: [],
    sort: null,
    url: "",
    resultsTotalCount: 0
};
